<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-11 mx-auto my-5 p-0">
        <div class="d-flex justify-content-between align-items-center pt-4">
          <Typography text="Ayuda" variant="h1" />
        </div>

        <div class="text-center mt-5">
          <embed :src="urlPdf" width="800" height="600" v-if="urlPdf">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useControllers from "@/controllers";
const { useScreenHooks } = useControllers();
const { useLegal } = useScreenHooks();
const { useProcess } = useLegal();
const { usHelp } = useProcess();

export default usHelp;
</script>
